export default __webpack_public_path__ + "static/media/thumbs_down.91e18a02.svg";